import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService, DictionaryEntry, PagedContentConfiguration, PagedContentType, SelectFieldOption, TranslationService } from '@sdbn/common';
import { TransortOptionParameterValue, TransportOption, TransportOptionParameter } from '../../transport-options.model';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-transport-option-editor-parameter',
  templateUrl: './transport-option-editor-parameter.component.html',
  styleUrls: ['./transport-option-editor-parameter.component.scss'],
  standalone: false
})
export class TransportOptionEditorParameterComponent implements OnInit {


  data = [];
  configuration = new PagedContentConfiguration({
    columns: [],
    itemDataAccessor: {
      getTitle: (item: any) => item['name'].getValue(this.translationService.language)?.value,
      getSubtitle: (item: any) => null,
      getIcon: (item: any) => null
    },
    desktopType: PagedContentType.SIDE_TAB_SINGLE,
    mobileType: PagedContentType.ICON_MENU_SINGLE
  });

  transportOption: TransportOption;
  @Input('transportOption') set setTransportOption(transportOption: TransportOption) {
    this.transportOption = transportOption;
    // this.updateVisibleParameterValues();
  }

  currentTransportOptionParameter: TransportOptionParameter | undefined;
  transportOptionParameterSelection: TransportOptionParameter | undefined;

  formGroup = new FormGroup({
    type: new FormControl(null, []),
  });

  options: Array<SelectFieldOption> = [
    new SelectFieldOption({ value: 'TEXT', labelDictionaryKey: 'TEXT' }),
    new SelectFieldOption({ value: 'SINGLE_SELECT', labelDictionaryKey: 'SINGLE_SELECT' }),
    new SelectFieldOption({ value: 'MULTI_SELECT', labelDictionaryKey: 'MULTI_SELECT' }),
  ];
  // legacy

  @Output() changed = new EventEmitter();

  currentEditingParameterValue: TransortOptionParameterValue | undefined;

  constructor(
    private translationService: TranslationService,
    private dialogService: DialogService
  ) {
  }

  public onSelectionChanged(parameter: any) {
    this.currentTransportOptionParameter = parameter;
    this.formGroup.patchValue({ type: parameter?.type });
  }

  public onAddAttribute(parameter: any) {
    console.log('adding');
    const newParameter = new TransportOptionParameter();
    newParameter.name = new DictionaryEntry();
    newParameter.name.values.push({ language: this.translationService.language, value: 'New Parameter ' + (this.transportOption.parameter.length + 1) });
    this.transportOption.parameter.push(newParameter);
    this.currentTransportOptionParameter = newParameter;
    this.transportOptionParameterSelection = newParameter;
    console.log('parameters are', this.transportOption.parameter);
  }

  onDeleteParameter(parameter: any) {
    this.dialogService.showConfirm('', '').afterClosed().subscribe(result => {
      if (result) {
        if (this.transportOption.parameter.indexOf(parameter) > -1) {
          this.transportOption.parameter.splice(this.transportOption.parameter.indexOf(parameter), 1);
        }
      }
    });
  }

  public ngOnInit() {
    this.formGroup.valueChanges.subscribe(value => {
      console.log('form value changed', value, this.currentTransportOptionParameter);
      if (this.currentTransportOptionParameter) {
        console.log('setting parameter type to', value.type);
        this.currentTransportOptionParameter.type = value.type;
      }
    });
  }

  onParameterNameChanged(entry: DictionaryEntry) {
    if (this.currentTransportOptionParameter == null) {
      return;
    }
    this.currentTransportOptionParameter.name = entry;
  }

  onParameterValueChanged(entry: DictionaryEntry) {
    if (this.currentEditingParameterValue == null) {
      return;
    }
    this.currentEditingParameterValue.value = entry;
  }

  addParameterValue() {

    if (this.currentTransportOptionParameter == null) {
      return;
    }

    let nextId = 0;

    for (const v of this.currentTransportOptionParameter!.values) {
      if (v.id < nextId) {
        nextId = v.id;
      }
    }
    nextId--;

    const value = new TransortOptionParameterValue({ id: nextId });
    this.currentTransportOptionParameter!.values.push(value);
    this.currentEditingParameterValue = value;
  }

  editParameterValue(value: TransortOptionParameterValue) {
    this.currentEditingParameterValue = value;
  }

  deleteParameterValue(value: TransortOptionParameterValue) {

    if (this.currentTransportOptionParameter) {
      if (this.currentTransportOptionParameter.values.indexOf(value) > -1) {
        this.currentTransportOptionParameter.values.splice(this.currentTransportOptionParameter.values.indexOf(value), 1);
      }
    }
  }

  unselectParameterValue() {
    this.currentEditingParameterValue = undefined;
  }
}
